import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveTeamDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.team.remove ;
}

RemoveTeamDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.teams.url,
    useUrl : true
};

RemoveTeamDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveTeamDialog );
